module.exports = __webpack_public_path__ + "static/media/math-arena-badge-scheme.620bb11a.png";